import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PAGES } from "@/content/pages";
import { GUIDES } from "@/content/guides";
import { Reveal } from "@/components/public/Blocks";

const FEATURES = ["wp-recipe-maker", "wp-delicious", "recipe-listicles", "recipefox-vs-chatgpt"];

export default function ExploreSection() {
    return (
        <section className="border-b border-line bg-white" data-testid="landing-explore">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-7">
                    <div className="overline mb-4">Go deeper</div>
                    <h2 className="heading text-3xl sm:text-4xl leading-tight mb-8">How it fits your WordPress setup</h2>
                    <div className="grid sm:grid-cols-2 gap-px bg-line border border-line">
                        {FEATURES.map((slug, i) => (
                            <Reveal key={slug} i={i} className="bg-white">
                                <Link to={`/${slug}`} className="group block p-6 h-full hover:bg-paperWarm transition-colors" data-testid={`explore-${slug}`}>
                                    <img src={PAGES[slug].image} alt="" loading="lazy" width="1264" height="848" className="w-full aspect-[16/9] object-cover mb-4 grayscale-[35%] group-hover:grayscale-0 transition-[filter] duration-500" />
                                    <div className="overline text-klein mb-2">{PAGES[slug].eyebrow}</div>
                                    <h3 className="font-semibold leading-snug flex gap-2">{PAGES[slug].h1}<ArrowUpRight className="w-4 h-4 shrink-0 mt-0.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></h3>
                                </Link>
                            </Reveal>
                        ))}
                    </div>
                </div>
                <div className="lg:col-span-5">
                    <div className="overline mb-4">Guides</div>
                    <ol className="border-t border-ink">
                        {GUIDES.map((g, i) => (
                            <li key={g.slug} className="border-b border-line">
                                <Link to={`/guides/${g.slug}`} className="group flex gap-4 py-4" data-testid={`explore-guide-${g.slug}`}>
                                    <span className="font-mono text-xs text-klein mt-1">{String(i + 1).padStart(2, "0")}</span>
                                    <span className="group-hover:text-klein transition-colors leading-snug">{g.title}</span>
                                </Link>
                            </li>
                        ))}
                    </ol>
                    <Link to="/guides" className="inline-flex items-center gap-2 mt-5 text-sm text-klein hover:underline" data-testid="explore-all-guides">All guides <ArrowUpRight className="w-4 h-4" /></Link>
                </div>
            </div>
        </section>
    );
}
